// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"EK-z","carouselContainer":"FK-z"};